import React, { useMemo } from 'react';
import { Modal, Typography, Box, IconButton } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'; // Material UI icon
import CloseIcon from "@mui/icons-material/Close";
import './ErrorOverlay.css'; // Import your CSS file

const ErrorOverlay = ({ error, onBackdropPress, visible }) => {
const errorMessage = useMemo(() => {
    const raw =
      error?.response?.data?.message ||
      error?.response?.data?.error?.message ||
      error?.message ||
      null;

    if (!raw) return null;

    if (typeof raw === "string") {
      return raw
        .split(/!|\n/) // split by "!" or newlines
        .map(err => err.trim())
        .filter(err => err.length > 0);
    }
    if (Array.isArray(raw)) {
      return raw;
    }

    return [String(raw)];
  }, [error]);

  return (
    <Modal
      open={visible}
      onClose={onBackdropPress}
      aria-labelledby="error-overlay-title"
      aria-describedby="error-overlay-description"
    >
      <Box className="error-overlay-container">
        <IconButton
          onClick={onBackdropPress}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>
        <ErrorOutlineIcon fontSize="large" color="error" />
        <div id="error-overlay-description" className="error-message">
          {!errorMessage ? (
            <Typography variant="h6">
              Check your connection then try again!
            </Typography>
          ) : (
            <ul>
              {errorMessage.map((msg, i) => (
                <li key={i} style={{listStyle: 'none'}}>
                  <Typography variant="body1">{msg}</Typography>
                </li>
              ))}
            </ul>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default ErrorOverlay;
